module.exports = __webpack_public_path__ + "be181977ac724531f4a39ad93676ca95.svg";